<template>
  <div class="px-4 pt-4">
    <BaseExperienceCard :post="post"></BaseExperienceCard>
    <div class="bottom--sticky z-index-2">
      <BaseSheet
        width="100%"
        :height="32"
        class="background--linear"
      ></BaseSheet>
      <div
        class="view-background-color d-flex justify-space-between pt-4 align-center"
      >
        <!-- Delete -->
        <BaseButton
          @click="confirmDeletePost = true"
          :disabled="isFetchingData"
          :height="40"
          :width="40"
          color="white"
          :fab="true"
          :elevation="$vuetify.breakpoint.xs ? 2 : 0"
          :depressed="!$vuetify.breakpoint.xs"
        >
          <BaseIcon color="error" :size="20">far fa-trash-alt</BaseIcon>
        </BaseButton>
        <div class="d-flex">
          <!-- Edit -->
          <BaseButton
            @click="$store.dispatch('share/openPostEditForm')"
            :disabled="isFetchingData"
            :depressed="!$vuetify.breakpoint.xs"
            color="white"
            :dark="true"
          >
            <span class="primary--text" v-text="$t('share.edit')"></span>
          </BaseButton>
          <!-- Confirm -->
          <BaseButton
            v-if="!post.isPublished"
            @click="$store.dispatch('share/publishPost')"
            :disabled="isFetchingData"
            v-text="$t('share.publish')"
            :depressed="!$vuetify.breakpoint.xs"
            color="primary"
            class="ml-4"
          ></BaseButton>
        </div>
      </div>
        <BaseSheet
          width="100%"
          :height="16"
          color="grey lighten-5"
          :light="false"
        ></BaseSheet>
    </div>
    <!-- Confirm delete Post Modal -->
    <BaseDialog v-model="confirmDeletePost" max-width="450">
      <BaseCard color="grey lighten-5">
        <div class="d-flex justify-space-between align-center px-4 py-2">
          <h3 v-text="$t('share.confirmDelete')"></h3>
          <BaseButton icon @click.stop="confirmDeletePost = false">
            <BaseIcon>close</BaseIcon>
          </BaseButton>
        </div>
        <BaseDivider></BaseDivider>
        <div
          class="d-flex justify-center align-center flex-wrap pa-4 text--primary text-center"
        >
          <div class="mx-6">
            <span>
              Etes vous sur de vouloir supprimer votre partage de gemme :
            </span>
            <br />
            <span v-text="post.title" class="font-weight-medium"></span>
            <span> ?</span>
          </div>
        </div>
        <BaseCardActions class="pa-4 d-flex justify-space-between">
          <BaseButton
            @click.stop="confirmDeletePost = false"
            color="primary"
            :depressed="!$vuetify.breakpoint.xs"
          >
            Annuler
          </BaseButton>
          <BaseButton
            color="white"
            :depressed="!$vuetify.breakpoint.xs"
            @click.stop="
              confirmDeletePost = false;
              $store.dispatch('share/deletePost');
            "
          >
            <span class="error--text">Supprimer</span>
          </BaseButton>
        </BaseCardActions>
      </BaseCard>
    </BaseDialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BaseExperienceCard from "../../core/components/BaseExperienceCard";
export default {
  components: {
    BaseExperienceCard
  },
  // DATAs
  data() {
    return {
      confirmDeletePost: false
    };
  },
  computed: {
    ...mapState({
      post: state => state.share.post,
      isFetchingData: state => state.share.isFetchingData
    })
  }
};
</script>

<style lang="scss" scoped>
.background--linear {
  background: linear-gradient(#f7f8f800, #f7f8f8);
}</style>
